import React, { useEffect } from "react";

import { Drawer as AntDrawer, DrawerProps as AntDrawerProps } from "antd";

import { trackMixpanel, useAppType } from "utils";

import { Icon, Link, Svg } from "components";

export type DrawerProps = AntDrawerProps & {
  visible: boolean;
  dataTestId?: string;
  fullHeight?: boolean;
  fullWidth?: boolean;
  isNavDrawer?: boolean;
  logoUrl?: string;
  wide?: boolean;
  zIndex?: number;
  hideCloseIcon?: boolean;
};

export const Drawer = ({
  visible,
  children,
  className = "",
  dataTestId = "",
  destroyOnHidden = true,
  footer,
  fullHeight = false,
  fullWidth = false,
  isNavDrawer = false,
  logoUrl = "",
  onClick = () => {},
  onClose = () => {},
  placement,
  title,
  wide = false,
  zIndex = 1002,
  hideCloseIcon,
  ...props
}: DrawerProps) => {
  const appType = useAppType();

  const getWidth = () => {
    if (props.width) {
      return props.width;
    }
    if (!appType.desktop && isNavDrawer) {
      return "20rem";
    }
    if (fullWidth || !appType.desktop) {
      return "100vw";
    }
    if (wide) {
      return "75vw";
    }
    return "644px";
  };

  const getPlacement = () => {
    if (placement) {
      return placement;
    }
    if (!appType.desktop && isNavDrawer) {
      return "left";
    }
    if (!appType.desktop) {
      return "bottom";
    }
    return "right";
  };

  useEffect(() => {
    if ((title || className) && visible) {
      trackMixpanel("DrawerOpened", { type: title || className });
    }
  }, [visible, className, title]);

  return (
    <AntDrawer
      data-testid={dataTestId}
      rootClassName={`klim-drawer ${footer ? "has-footer" : ""} ${fullHeight ? "fullHeight" : ""} ${className}`}
      footer={footer}
      height={fullHeight ? "100vh" : props.height}
      placement={getPlacement()}
      title={
        <>
          {isNavDrawer && appType.mobile && (
            <Link to={logoUrl ?? "/"} onClick={onClose} mixpanelText={title as string}>
              <Svg svgName="logos/klim_logo_text_black" width={75} height={32} />
            </Link>
          )}
          <h4>{title}</h4>
        </>
      }
      open={visible}
      width={getWidth()}
      onClick={onClick}
      onClose={onClose}
      closeIcon={hideCloseIcon ? null : <Icon iconName="tabler/x" size="m" dataTestId={"drawer-close-button"} />}
      destroyOnHidden={destroyOnHidden}
      zIndex={zIndex}
      {...props}
    >
      {children}
    </AntDrawer>
  );
};
